import React from 'react';
import {device} from '../MainContents/Style/StyleDevice'
import styled from 'styled-components';
import ScrollToTopOnMount from '../MainContents/AutoScrollTop'; 
import sam4 from '../../img/TopBanner.png';

const ImgDown = styled.div`
  margin-top:70px;
  @media ${device.laptop} { 
    margin-top:80px;
  }
`;
const Img = styled.img`
  width: 100%;
  height: 90vh;
  object-fit: cover;
  @media ${device.laptop} { 
    height: initial;
  }
`;

// お知らせ　ご案内
class CurrentNews extends React.Component {
    render() {
      return (
          <div>
            <ScrollToTopOnMount />
              <ImgDown className="card bg-dark text-white">
                <Img src={sam4}/>
              </ImgDown>
          </div>
      );
    }
}
export default CurrentNews